import Android from './Android'

export default Android
// eslint-disable-next-line import/export
export * from './Android'
